import { useEffect, useRef } from "react";

import { StepContainer } from "./IdentityVerification.styles";
import incode from "incode";

interface FrontIdProps {
  session: any;
  onSuccess: () => void;
  onError: (e?: any) => void;
}

function FrontId({ session: token, onSuccess, onError }: FrontIdProps) {
  const containerRef = useRef(null);
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }

    if (containerRef.current && incode) {
      incode.renderCamera("front", containerRef.current, {
        onSuccess,
        onError,
        token,
        numberOfTries: -1,
        showTutorial: true,
        showCustomCameraPermissionScreen: true,
        // showDoublePermissionsRequest: true,
        showAutoCaptureIDOverlay: false,
        showManualCaptureIDOverlay: true,
        nativeCamera: true,
      });
    }

    isMounted.current = true;
  }, [onSuccess, onError, token]);

  if (!incode) {
    return null;
  }

  return <StepContainer className="incode_front-id" ref={containerRef} />;
}

export default FrontId;
